import React from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { FloatingLocationInfoContent } from 'views/common/components';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import PATHS from 'lib/navigation/paths';
import Typography500 from 'views/common/components/UI/Typography500';
import StyledDialog from 'views/rebranded-module/common/components/UI/FloatingLocationInfoV2/FloatingLocationInfoV2.styles';
import { ImgBox } from 'views/rebranded-module/common/components';

const FloatingLocationInfoV2 = (props) => {
  const {
    name,
    address,
    phones,
    operationHours,
    locationSlug,
    handleClose,
    open,
    handleBook,
    className,
    isClubMember = false,
    content,
  } = props;

  return (
    <>
      <StyledDialog
        open={open}
        onClose={handleClose}
        disableRestoreFocus
        maxWidth="xs"
        container={() => document.getElementById('mapContainer')}
        className={`FLIDialogFloatingLocation ${className}`}>
        <Typography variant="span" className="FLITRI" />
        <DialogTitle
          className="FLIDialog FLIDialogHeader"
          onClose={handleClose}>
          <Box className="FLITitle">
            <Box>
              <Box className="FLIBadge">
                <ImgBox
                  image={{
                    src: '/imgs/logo-badge.svg',
                    alt: 'badge',
                  }}
                  width="100%"
                  height="100%"
                  objectFit="contain"
                />
              </Box>
            </Box>
            <Box className="FLIBsadgeAndName">
              <Typography500
                component="span"
                variant="h5"
                className="FLILocationText"
                mr={1}>
                {name}
              </Typography500>

              {isClubMember && (
                <Typography component="span" className="FLIERBadge">
                  {content.clubEaglerider}
                </Typography>
              )}
            </Box>
          </Box>
          {handleClose ? (
            <IconButton className="FLICloseBtn" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent className="FLIDialog FLIInfoContent">
          <FloatingLocationInfoContent
            className="FLIDialog"
            address={address}
            phones={phones}
            operationHours={operationHours}
          />
        </DialogContent>
        <DialogActions className="FLIDialog">
          <Grid container alignItems="center">
            {locationSlug && (
              <Grid item>
                <NavigatorLink
                  href={PATHS.locationSlug(locationSlug)}
                  className="FLILocDetails">
                  <Button
                    onClick={handleClose}
                    color="primary"
                    className="FLILocationDetailsBtn"
                    size="large">
                    <Typography className="FLILocbtn">
                      {content.locationDetails}
                    </Typography>
                    <OpenInNewIcon className="FLILocDetailsIcon" />
                  </Button>
                </NavigatorLink>
              </Grid>
            )}
            {handleBook && (
              <Grid item className="FLIBtnPos">
                <Button
                  onClick={handleBook}
                  color="primary"
                  variant="contained"
                  className="FLIBookbtn">
                  {content.bookNow}
                </Button>
              </Grid>
            )}
          </Grid>
        </DialogActions>
      </StyledDialog>
    </>
  );
};
export { FloatingLocationInfoV2 };
